import { render, staticRenderFns } from "./BasicRatingLayout.vue?vue&type=template&id=75269020"
import script from "./BasicRatingLayout.vue?vue&type=script&lang=ts"
export * from "./BasicRatingLayout.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports